import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Admin/Sidebar';
import { User as UserIcon, Menu } from 'lucide-react';
import { useAuth } from '../Context/AuthContext';
import '../Styles/Admin.css';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // Close mobile sidebar on route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);



  return (
    <div className={`admin-layout ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-sidebar-open' : ''}`}>
      {/* Mobile Backdrop */}
      {isMobileOpen && (
        <div 
          className="admin-backdrop" 
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} isMobileOpen={isMobileOpen} />
      
      <main className="admin-main">
        <header className="admin-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
            <button 
              onClick={() => {
                if (window.innerWidth < 992) {
                  setIsMobileOpen(!isMobileOpen);
                } else {
                  setIsCollapsed(!isCollapsed);
                }
              }}
              className="header-toggle-btn"
              style={{ background: 'none', border: 'none', color: 'var(--text-main)', cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '0.5rem', borderRadius: '0.5rem', transition: 'background 0.2s' }}
            >
              <Menu size={24} />
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: 'var(--primary-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--primary)', flexShrink: 0 }}>
                <UserIcon size={18} style={{ color: 'var(--primary)', margin: 'auto' }} />
              </div>
              <div className="md:flex hidden flex-col">
                <span style={{ fontSize: '0.85rem', fontWeight: '700' }}>{user?.username || 'Admin'}</span>
                <span style={{ fontSize: '0.7rem', color: 'var(--text-dim)', marginTop: '-2px' }}>{user?.role === 'admin' ? 'Yönetici' : 'Kullanıcı'}</span>
              </div>
            </div>

          </div>
        </header>

        <section className="admin-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
};

export default AdminLayout;
